import { AdminScaleChildType } from '@business/entities/adminscale';

export function getTypeDescriptions() {
  return {
    [AdminScaleChildType.goals]: 'A goal is a known objective toward which actions are directed with the purpose of achieving that end.',
    [AdminScaleChildType.purposes]: 'A purpose is a lesser goal applying to specific activities or subjects. It often expresses future intentions.',
    [AdminScaleChildType.policy]: 'Policy consists of the operational rules or guides for the organization which are not subject to change.',
    [AdminScaleChildType.plans]:
      'A plan is a short-range broad intention thought up for the handling of a broad area to remedy it or expand it, or to obstruct or impede an opposition to expansion.',
    [AdminScaleChildType.programs]: 'A program is a series of steps in sequence to carry out a plan.',
    [AdminScaleChildType.orders]: 'An order is a verbal or written direction to carry out a program step or apply general policy.',
    [AdminScaleChildType.idealScenes]:
      'An ideal scene expresses what a scene or area ought to be. If one has not envisioned an ideal scene with which to compare the existing scene, he will not be able to recognize departures from it.',
    [AdminScaleChildType.statistics]:
      'A statistic is a number or amount compared to an earlier number or amount of the same thing. Statistics refer to the quantity of work done or the value of it.',
    [AdminScaleChildType.valuableFinalProducts]:
      'A valuable final product is a product that can be exchanged for the services or goods of the society.',
  };
}

export function getTypeDescription(type: AdminScaleChildType) {
  return getTypeDescriptions()[type];
}

export function getTypeSingular(type: AdminScaleChildType) {
  switch (type) {
    case AdminScaleChildType.goals:
      return 'Goal';
    case AdminScaleChildType.purposes:
      return 'Purpose';
    case AdminScaleChildType.policy:
      return 'Policy';
    case AdminScaleChildType.plans:
      return 'Plan';
    case AdminScaleChildType.programs:
      return 'Program';
    case AdminScaleChildType.orders:
      return 'Order';
    case AdminScaleChildType.idealScenes:
      return 'Ideal Scene';
    case AdminScaleChildType.statistics:
      return 'Statistic';
    case AdminScaleChildType.valuableFinalProducts:
      return 'Valuable Final Product';
  }
}
